// Shown inside the layout while a page's code is downloaded for the first time,
// so the sidebar and header stay put.
export default function PageLoading() {
  return (
    <div className="flex items-center justify-center h-64" role="status" aria-label="Loading page">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent" />
    </div>
  );
}
